import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
export default function CreateWaveInlineGroupSearch(t0) {
  const $ = _c(5);
  const {
    defaultLabel,
    disabled,
    selectedGroup,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== defaultLabel || $[1] !== disabled || $[2] !== onSelect || $[3] !== selectedGroup) {
    t1 = <div className="tw-space-y-3"><CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={disabled} selectedGroup={selectedGroup} onSelect={onSelect} /></div>;
    $[0] = defaultLabel;
    $[1] = disabled;
    $[2] = onSelect;
    $[3] = selectedGroup;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}